import { Mitarbeiter_FeiertagskontoKontoausgleichArt } from '@/gql/graphql';

export class Kontoausgleiche {
  constructor({
    datum,
    art,
    bemerkung,
    tage,
  }: {
    datum: string;
    art: KontoausgleicheArt;
    bemerkung: string;
    tage: number;
  }) {
    this.datum = datum;
    this.art = art;
    this.bemerkung = bemerkung;
    this.tage = tage;
  }
  datum: string;
  art: KontoausgleicheArt;
  bemerkung: string;
  tage: number;
}

export enum KontoausgleicheArt {
  FEIERTAGSAUSZAHLUNG = 'Feiertagsauszahlung',
  FEIERTAGSKORREKTUR = 'Feiertagskorrektur',
}

export const mappedKontoausgleicheArt = (
  status: Mitarbeiter_FeiertagskontoKontoausgleichArt,
): KontoausgleicheArt => {
  switch (status) {
    case Mitarbeiter_FeiertagskontoKontoausgleichArt.Feiertagsauszahlung:
      return KontoausgleicheArt.FEIERTAGSAUSZAHLUNG;
    case Mitarbeiter_FeiertagskontoKontoausgleichArt.Feiertagskorrektur:
      return KontoausgleicheArt.FEIERTAGSKORREKTUR;
  }
};
